import styled from 'styled-components';
import {MdEmail, MdLocalPhone} from 'react-icons/md';

/* Importaciones propias */
import {ContactInfoItem} from './ContactInfoItem';
import {SectionTitle} from '../ui/SectionTitle';

const ContactSectionStyle = styled.div`
  padding: 10rem 0;

  .contactSection__wrapper {
    display: flex;
    gap: 5rem;
    margin-top: 7rem;
    justify-content: space-between;
    position: relative;
  }

  .contactSection__wrapper::after {
    position: absolute;
    content: '';
    width: 2px;
    height: 50%;
    background-color: var(--gray-1);
    left: 50%;
    top: 30%;
    transform: translate(-50%, -50%);
  }

  .left {
    width: 100%;
    max-width: 500px;
  }

  .right {
    max-width: 500px;
    width: 100%;
    border-radius: 12px;
    /* padding-left: 3rem; */
  }

  @media only screen and (max-width: 768px) {
    .contactSection__wrapper {
      flex-direction: column;
    }

    .contactSection__wrapper::after {
      display: none;
    }

    .left,
    .right {
      max-width: 100%;
    }

    .right {
      padding: 4rem 2rem 2rem 2rem;
    }
  }
`;

export const ContactSection = () => {
    return (
        <ContactSectionStyle>
            <div className="container">
                <SectionTitle heading="contacto" subheading="Ponte en contacto"/>
                <div className="contactSection__wrapper">
                    <div className="left">
                        <ContactInfoItem icon={<MdLocalPhone/>} text="+51983416698"/>
                        {/*<ContactInfoItem icon={<MdEmail/>} text="arian.angoma.js@gmail.com"/>*/}
                    </div>
                    <div className="right">
                        <ContactInfoItem icon={<MdEmail/>} text="arian.angoma.js@gmail.com"/>
                    </div>
                    {/*<div className="right">
                        <ContactForm/>
                    </div>*/}
                </div>
            </div>
        </ContactSectionStyle>
    )
}
